import React, { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { loggerInfo } from '@nile/home/src/coralogixRUM';

const LDDebugger = (props) => {
  const ldClient = useLDClient();
  const { currentUser } = props;
  useEffect(() => {
    if (!ldClient) return;

    ldClient
      ?.waitForInitialization()
      .then(() => {
        console.log('LaunchDarkly Initialized');
      })
      .catch((err) => {
        console.error('LD Initialization Failed:', err?.message);
        // if (window.logger) {
        //   window.logger.info('LD initialization failed', {
        //     error: err?.message,
        //     hashURL: window.location.hash,
        //     customerId: currentUser?.customerId,
        //     userId: currentUser?.userId,
        //     user: currentUser?.email,
        //     userAgent: window?.navigator?.userAgent
        //   });
        //   window.logger.flush();
        // }
        loggerInfo('LD initialization failed', {
          error: err?.message,
          hashURL: window.location.hash,
          customerId: currentUser?.customerId,
          userId: currentUser?.userId,
          user: currentUser?.email,
          userAgent: window?.navigator?.userAgent
        });
      });
  }, [ldClient]);

  return null; // this component just logs
};

export default LDDebugger;
